import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import CloseIcon from '../../assets/img/ico-close.svg?react'
import LoupeIcon from '../../assets/img/ico-loupe.svg?react'
import MagnifyIcon from '../../assets/img/ico-magnify.svg?react'

const SearchHeader: React.FC = () => {
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        const query = searchParams.get('search')

        if (query) {
            setIsSearchOpen(true)
            setSearchValue(query)
        } else {
            setIsSearchOpen(false)
        }
    }, [searchParams])

    const handleSearchToggle = () => {
        setIsSearchOpen(!isSearchOpen)
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value)
    }

    const handleSearchSubmit = (event: React.FormEvent) => {
        event.preventDefault()
        const params = new URLSearchParams()
        if (searchValue) {
            params.set('search', searchValue)
            navigate(`/search?${params.toString()}`)
        }
    }

    return (
        <div className="search-header">
            <form
                className={clsx('search-form', {
                    '--show-search': isSearchOpen,
                })}
                onSubmit={handleSearchSubmit}
            >
                <div className="input-wrapper input--xl input--shadow search-form-row full-radius">
                    <div className="search-form-toggler input-wrapper search-form-row input--shadow input--xl full-radius">
                        <button
                            type="submit"
                            className="btn text-color-1 search-btn"
                        >
                            <span className="ico">
                                <MagnifyIcon />
                            </span>
                        </button>
                        <input
                            className="input font-2"
                            type="text"
                            placeholder="Search information..."
                            value={searchValue}
                            onChange={handleInputChange}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-tool search-btn toggle-btn-search"
                        onClick={handleSearchToggle}
                    >
                        <span className="ico --show">
                            <LoupeIcon />
                        </span>
                        <span className="ico --hide">
                            <CloseIcon />
                        </span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default SearchHeader
